<template>
  <div class="qrcode" ref="rccode"></div>
</template>
<script>
import QRCode from 'qrcodejs2';
export default {
  name: 'VueQr',
  props: {
    text: {
      type: String,
      default:''
    }
  },
  data() {
    return {}
  },
  mounted() {
     this.currentMethods()
  },
  methods: {
    currentMethods() {
      new QRCode(this.$refs.rccode, {
        text: this.text,
        width: 200,
        height: 200,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H,
      })
    },
  },
}
</script>

<style lang="less" scoped>
.qrcode {
  width: 100%;
  height: 100%;
}
</style>